import Background from 'components/common/Background';
import CardDropdown from 'components/common/CardDropdown';
import FalconCardHeader from 'components/common/FalconCardHeader';
import cornerBg from 'assets/img/illustrations/corner-2.png';
import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const InfoItem = ({ title, content, className }) => {
  return (
    <div className={classNames('mb-4', className)}>
      <h6
        className={classNames({
          'mb-1': title === 'Email' || title === 'Phone Number'
        })}
      >
        {title}
      </h6>
      {title === 'Email' && (
        <a className="fs--1" href={`mailto: ${content}`}>
          {content}
        </a>
      )}
      {title === 'Phone Number' && (
        <a className="fs--1" href={`tel: ${content.replace(/\s+/g, '')}`}>
          {content}
        </a>
      )}
      {title !== 'Email' && title !== 'Phone Number' && (
        <p className="mb-0 text-700 fs--1">{content}</p>
      )}
    </div>
  );
};

InfoItem.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  className: PropTypes.string
};

const ContactProfile = ( { dataAlumno } ) => {
  console.log(dataAlumno);
  return ( 
    <Card className="mb-xl-3">
      <FalconCardHeader
        title="Datos"
        titleTag="h6"
        className="py-2"
        endEl={<CardDropdown />}
      />
      <Card.Body className="bg-light">
        <Card className="border rounded-3 bg-white dark__bg-1000 shadow-none">
          <Background
            image={cornerBg}
            className="bg-card d-none d-sm-block d-xl-none"
          />
          <Card.Body className="row g-0 flex-column flex-sm-row flex-xl-column z-index-1 align-items-center">
            {/*<Col xs="auto" className="text-center me-sm-x1 me-xl-0">
              <img className="ticket-preview-avatar" src={profileImg} alt="" />
            </Col> */}
            <Col sm={8} md={6} lg={4} xl={12} className="ps-sm-1 ps-xl-0">
              <p className="fw-semi-bold mb-0 text-800 text-center text-sm-start text-xl-center mb-3 mt-3 mt-sm-0 mt-xl-3">
                { dataAlumno.firstName +' '+ dataAlumno.lastName }
              </p>
            </Col>
          </Card.Body>
        </Card>
        <Row className="border rounded-3 p-x1 mt-3 bg-white dark__bg-1000 mx-0 g-0">
          <Col md={6} xl={12} className="pe-md-4 pe-xl-0">   
            <InfoItem title="Phone Number" content={dataAlumno.phone} /> 
            <InfoItem title="Email" content={dataAlumno.email} />
            <InfoItem title="Direccion" content={dataAlumno.address} />
            <InfoItem
              title="Sexo"
              content={dataAlumno.gender}
            />
          </Col>
          <Col md={6} xl={12} className="ps-md-4 ps-xl-0">
            <InfoItem title="Nacimiento" content={ dataAlumno.birthDate} />
          </Col>
          <Col sm={8} md={6} lg={4} xl={12} className="ps-sm-1 ps-xl-0">
              <p className="fw-semi-bold mb-0 text-800 text-center text-sm-start text-xl-center mb-3 mt-3 mt-sm-0 mt-xl-3">
                { "Datos del Tutor" }
              </p>
            </Col>
          <Col>
            <InfoItem title='Nombre y Apellido' content={dataAlumno.guardianName?dataAlumno.guardianName:'No Informado'} />
            <InfoItem title='DNI' content={dataAlumno.guardianDNI? dataAlumno.guardianDNI:'No Informado'} />
            <InfoItem title='Email' content={dataAlumno.guardianEmail? dataAlumno.guardianEmail:'No Informado'} />
            <InfoItem title='Celular' content={dataAlumno.guardianPhone? dataAlumno.guardianPhone:'No Informado' } />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

ContactProfile.propTypes = {
  dataAlumno: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
    address: PropTypes.string,
    birthDate: PropTypes.string,
    gender: PropTypes.string,
    guardianName: PropTypes.string,
    guardianEmail: PropTypes.string,
    guardianDNI: PropTypes.string,
    guardianPhone: PropTypes.string,
  }),
};
export default ContactProfile;
